import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import PenggunaService from "../../../services/pengaturan/PenggunaService";

export const initialState = {
    loading: false,
    data_pengguna: [],
    data_pengguna_detail: [],
    data_import:[],
    showMessage:false,
    message:'',
}


export const getDataPengguna = createAsyncThunk('pendaftar/data',async (data, { rejectWithValue }) => {
    try {
        const response = await PenggunaService.data(localStorage.getItem(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataPenggunaDetail = createAsyncThunk('pendaftar/detail',async (data, { rejectWithValue }) => {
    try {
        const response = await PenggunaService.detail(localStorage.getItem(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('pendaftar/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await PenggunaService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('pendaftar/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await PenggunaService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('pendaftar/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await PenggunaService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const penggunaSlice = createSlice({
    name: 'pengguna',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPengguna.fulfilled, (state, action) => {
                state.loading = false
                state.data_pengguna = action.payload
            })
            .addCase(getDataPengguna.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataPengguna.rejected, (state, action) => {
                state.loading = false
                state.data_pengguna = action.payload
            })
            .addCase(getDataPenggunaDetail.fulfilled, (state, action) => {
                state.loading = false
                state.data_pengguna_detail = action.payload
            })
            .addCase(getDataPenggunaDetail.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataPenggunaDetail.rejected, (state, action) => {
                state.loading = false
                state.data_pengguna_detail = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading= false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = penggunaSlice.actions

export default penggunaSlice.reducer
